import React, { useState } from 'react'
import {
    CLOSEICON
} from "../../constants/imagepath";
import Skeleton from "react-loading-skeleton";
import { updateJobStatus } from "../../api_services/api_calls/jobsApi";
import { toast } from "react-toastify";
const UpdateJobStatusModal = ({ isOpen, onClose, jobDetail, userData, refreshJobs }) => {
    const [jobStatus, setJobStatus] = useState("");
    const [loading, setLoading] = useState(false);
    const [isdisabled,setIsDisabled]=useState(true)
    const updateStatus = () => {
        setLoading(true);
        setIsDisabled(true)
        let obj = { id: jobDetail.id, job_status: jobStatus }
        updateJobStatus(obj).then(function (resp) {
            //setHasMoreItems(false);
            setLoading(false);
            if (resp.data.status === true) {
                toast.success(resp.data.message);
                refreshJobs();
            } else {
                toast.error(resp.data.message);
            }
            // close the modal
            closePackageModal()
        }).catch(function (error) {
            toast.error("Something went wrong");
            // close the modal
            closePackageModal()
        });
    }
    const closePackageModal = () => {
        onClose(!isOpen);
    };
    return (
        <>
            {isOpen ?
                <div id="productPopup" className="overlay_2 text-left">

                    <div className="popup1">
                        <div className="row">
                            <div className="popup-header custom-close-btn px-5 py-3">
                                <a className="close" href="javascript:void(0)">
                                    <img
                                        alt="closeIcon"
                                        src={CLOSEICON}
                                        onClick={closePackageModal}
                                    />
                                </a>
                            </div>
                            <div className="row p-4">
                                {
                                    (jobDetail.length === 0)
                                        ?
                                        <Skeleton count={7.7} />
                                        :
                                        <div className="col-md-12">
                                            <div className="row">
                                                <h6 className='ml-2'>
                                                    Please select the job status for <strong className="ct_color_1">{jobDetail?.title}</strong>
                                                </h6>
                                            </div>
                                            {
                                                (jobDetail?.user_id === userData?.id) ?
                                                    <>
                                                        <div className="row form-group mb-3">
                                                            <label for="jobStatus" className="col-sm-4 t_fw_600 ct_fs_16"> Job Status</label>
                                                            <div className="col-sm-8">
                                                                <select id="jobStatus" className="form-select" value={jobStatus} onChange={(e) => {
                                                                    setIsDisabled(false)
                                                                    setJobStatus(e.target.value)
                                                                }}>
                                                                    <option value="1">Running</option>
                                                                    <option value="2">Complete</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-8">
                                                            <button disabled={isdisabled} onClick={updateStatus}>{loading ? 'Updating...' : 'Update'}</button>
                                                        </div>
                                                    </> :
                                                    ""
                                            }
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                : ""}
        </>
    )
}

export default UpdateJobStatusModal